import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

const Background = styled.div`
  color: #000;
  position: fixed;
  z-index: 200;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.65);
  display: grid;
  place-items: center;
  top: 0;
  right: 0;
  transition: 0.3s ease-in-out;
  opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
  right: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
`;

const Content = styled.div`
  color: #fff;
  text-align: center;

  .spinner {
    display: flex;
    justify-content: center;
  }
`;

const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: inline-block;
  width: ${(props) => props.size || '40px'};
  height: ${(props) => props.size || '40px'};
  border: 4px solid rgba(237, 250, 250, 1);
  border-top: 4px solid #549a9a;
  border-radius: 50%;
  animation: ${spinAnimation} 1s linear infinite;
`;

const LoadingScreen = ({ size, isOpen, ...props }) => {
  return (
    <div>
      <Background isOpen={isOpen} {...props}>
        <Content>
          <div className="spinner">
            <SpinnerContainer size={size} />
          </div>
          <p>Processing Payment</p>
        </Content>
      </Background>
    </div>
  );
};

export default LoadingScreen;

LoadingScreen.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  size: PropTypes.string,
};

LoadingScreen.defaultProps = {
  size: '',
};
